import React from 'react'
import './HomeAdvantages.scss'
import HomeAdvantagesCard from './HomeAdvantagesCard/HomeAdvantagesCard'

/*
  Преимущества — без карточек и без слайдера: три колонки, на мобиле
  строки «иконка слева, текст справа». Секция переиспользуется на
  /video, /hosting и /whois; active там центрирует заголовок и колонки,
  это поведение осталось, только переехало из инлайновых стилей в класс.
*/
const HomeAdvantages = ({ homeAdvantagesCardData, title, active }) => {
  return (
    <div className='homeAdvantages_container'>
      <div className={'homeAdvantages_block' + (active ? ' homeAdvantages_block--center' : '')}>
        <h1>{title}</h1>
        <div className="homeAdvantages_item">
          {homeAdvantagesCardData?.map((e, i) => (
            <HomeAdvantagesCard
              key={e.id ?? i}
              img={e.img}
              title={e.title}
              subTitle={e.subTitle}
              active={active}
              activeCard={e.activeCard}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default HomeAdvantages
